import { useState } from "react";
import { useNavigate } from "react-router-dom";

const TermsPage = () => {
	const navigate = useNavigate();
	const [agreed, setAgreed] = useState(false);

	const handleAgree = () => {
		if (!agreed) return;
		localStorage.setItem("agreedToTerms", "true");
		navigate("/howto");
	};

	return (
		<div className="min-h-screen bg-[#232222] text-white p-10 flex flex-col justify-center items-center">
			<div className="max-w-3xl w-full bg-[#2F2D2D] p-8 rounded-xl border border-white shadow-2xl overflow-y-auto max-h-[80vh]">
				<h2 className="text-4xl font-bold mb-6 text-center">
					Terms and Conditions
				</h2>

				<div className="text-lg space-y-4 text-white-300">
					<p>
						<strong>Summary:</strong>
					</p>
					<p>
						We’d love for you to join our research study! Pounce! is a community
						science project led by Dr. Elinor Karlsson at the University of
						Massachusetts Chan Medical School in partnership with the Broad
						Institute of MIT and Harvard.
					</p>
					<p>
						The first phase of this study tests a new way to collect animal
						behavior data from videos. We want to see if community members like
						you can agree on accurate measurements of behaviors they see in
						short video clips. This document explains the study’s goals, how
						your contributions will be used, what information we’ll collect, and
						how we’ll keep your data safe.
					</p>

					<p>
						<strong>What’s the main goal of the first phase of Pounce!?</strong>
					</p>
					<p>
						In many fields of study, researchers use video footage to study
						behavior. However, this process is time-consuming and usually
						requires trained experts. We want to find out if a large group of
						non-experts can speed up this process by identifying behaviors in
						short videos.
					</p>
					<p>
						If this approach works, then we will build a website where
						researchers can reach a wide audience of volunteers. These
						volunteers can help researchers extract data from videos to advance
						scientific discovery. 
					</p>

					<p>
						<strong>Your participation in this project</strong>
					</p>
					<p>
						Joining is your choice. If you decide to participate, you’ll first
						watch a short tutorial to learn how to spot a single behavior in
						puppies. Then, you’ll watch up to 80 one-minute video clips and mark
						when that behavior happens. You do not need to watch all 80 videos
						to participate.
					</p>
					<p>
						You can watch these videos at your own pace and take breaks whenever
						you want. If you leave the website and come back later, your work
						will be saved. You can stop participating at any time.
					</p>
					<p>
						By participating, you agree to give the investigators at the
						University of Massachusetts Chan Medical School and the Broad
						Institute permission to use your answers to test how well this
						process works. You will not be paid for your participation.
					</p>

					<p>
						<strong>Privacy Policy </strong>
					</p>
					<p>
						To join, you’ll use your email address to create a Pounce! account.
						This lets you stop your progress at any time and come back later.
					</p>

					<p>
						Your email will only be shared with staff who need it for managing
						the project. Your email address will be stored separately from your
						responses and personal data.
					</p>

					<p>
						If you have questions, you can contact our Principal Investigator,
						Dr. Elinor Karlsson, at <a href="mailto:pounceforscience@gmail.com" className="underline">pounceforscience@gmail.com</a>. 
						You can also submit questions and feedback using our <a href="https://forms.gle/PiZTTiFWzekDyPR29" className="underline" target="_blank">Google Form</a>. 
						We’re here to make sure you have a great experience!
					</p>
				</div>

				<div className="mt-6 flex items-start space-x-3">
					<input
						type="checkbox"
						id="agree"
						checked={agreed}
						onChange={() => setAgreed((prev) => !prev)}
						className="form-checkbox h-5 w-5 accent-[#C6E675]"
					/>
					<label htmlFor="agree" className="text-lg text-white font-medium">
						I agree to the Terms of service and Privacy Policy
					</label>
				</div>

				<div className="mt-6 flex justify-center">
					<button
						type="button"
						onClick={handleAgree}
						disabled={!agreed}
						className={`px-12 py-3 rounded-lg font-semibold transition ${
							agreed
								? "bg-[#a5bd6a] text-black hover:bg-[#A8D944]"
								: "bg-gray-500 text-gray-300 cursor-not-allowed"
						}`}
					>
						Continue
					</button>
				</div>
			</div>
		</div>
	);
};

export default TermsPage;
